/**
 * "Is this page inside the app shell?" — pages inside it skip their own header.
 * Kept out of AppShell.tsx (a component file) so a hot reload in development
 * never re-creates the context under pages that are already open.
 */

import { createContext, useContext } from 'react'

export const InShell = createContext(false)
/** True when the page is rendered inside the app shell (so it hides its own header). */
export const useInShell = () => useContext(InShell)
